const storageKeys = {
  USER: 'lettucegrow-user-012022',
  CART: 'lettucegrow-cart-012022',
};

export default storageKeys;
